import React from 'react';
import Chunk from 'components/Chunk';

const loadOrdersContainer = () => import('./containers' /* webpackChunkName: "orders" */);

const Orders = () => <Chunk load={loadOrdersContainer} />;

export default Orders;


// WEBPACK FOOTER //
// ./routes/Orders/index.jsx